import React from "react";
import { SxStyleProp } from "theme-ui";
import Box from "../Box/Box";

interface Props {
  sx?: SxStyleProp;
}

const VisuallyHidden: React.FunctionComponent<Props> = ({
  sx,
  ...restProps
}) => (
  <Box
    sx={{
      border: 0,
      clip: "rect(0, 0, 0, 0)",
      height: "1px",
      width: "1px",
      margin: "-1px",
      padding: "0px",
      overflow: "hidden",
      whiteSpace: "nowrap",
      position: "absolute",

      ...(sx as any),
    }}
    {...restProps}
  />
);

export default VisuallyHidden;
